(() => {
  'use strict';
  if (window.USFLanguageSync) return;
  const nativeFetch = (window.__usfNativeFetch || window.fetch).bind(window);
  const aliases = {'zh-hans':'zh-CN','zh-cn':'zh-CN','pt-pt':'pt','nb':'no','nn':'no'};
  const raw = (document.documentElement.lang || 'en').toLowerCase();
  const language = aliases[raw] || raw.split('-')[0];
  const records = new WeakMap();
  const attributeRecords = new WeakMap();
  const cacheKey = 'usf-language-v2-' + language;
  const cache = Object.assign(Object.create(null), window.USFLanguageSeeds?.[language] || {});
  try { Object.assign(cache, JSON.parse(window.localStorage.getItem(cacheKey) || '{}')); } catch {}
  const excluded = 'script,style,noscript,svg,canvas,code,pre,textarea,[contenteditable],.notranslate,[translate="no"],[data-usf-no-translate],.localization,localization-form,.shopify-localization-form,.customer,.account,.addresses,[data-customer],.uf-layer,.uf-layer-row,[data-ui="layers"],[data-ui="layer-list"],[data-ui="project-name"],[data-ui="library-grid"],[data-ui="creative-caption"],[data-ui="creative-result"],[data-ui="ai-result"]';
  const brands = /^(?:USASTARFASHION|LabStudio|Printlab|Printlab Studio|Shop Pay|PayPal|Visa|Mastercard|Apple Pay|Google Pay|Klarna|Gildan|Fruit of the Loom|Amex|Clearpay|Beechfield|Babybugz)$/i;
  const attributes = ['title','aria-label','aria-description','placeholder','alt'];
  const inFlight = new Set();
  let running = false, scheduled = false, timer, failures = 0;
  function source(text) {
    const value = String(text || '').replace(/\s+/g,' ').trim();
    if (!value || value.length > 12000 || brands.test(value)) return '';
    if (!/\p{L}{2}/u.test(value) || /^(?:https?:|data:|blob:)/i.test(value) || /^[^\s]+@[^\s]+$/.test(value)) return '';
    if (/^(?:#[a-f\d]{3,8}|[\d\s£$€¥₺.,%+\-:/×#]+)$/i.test(value)) return '';
    return value;
  }
  function visible(element) {
    return !element.closest('[hidden],[aria-hidden="true"]') && element.getClientRects().length > 0;
  }
  function record(node, value, old) {
    if (!old || (value !== old.original && value !== old.translated)) return {original:value, translated:null};
    return old;
  }
  function collect() {
    const items = [];
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const parent = node.parentElement;
      if (!parent || parent.closest(excluded) || (!visible(parent) && parent.id!=='uf-title')) continue;
      // Text in fields and user artwork is never translated or sent to the translation service.
      if (parent.closest('input') || (parent.closest('.uf-stage')&&!parent.closest('.uf-preview-disclaimer')) || (parent.closest('option') && !parent.closest('option').hasAttribute('value'))) continue;
      if(parent.closest('#uf-title') && node.nodeValue.trim()!=='Untitled creation' && !records.has(node)) continue;
      const state = record(node,node.nodeValue,records.get(node)); records.set(node,state);
      const key = source(state.original);
      if (key) items.push({key,state,node});
    }
    // Capture each node separately; callbacks must not refer to the walker variable.
    for (const item of items) item.write = value => {const output=item.state.original.replace(/\S[\s\S]*\S|\S/,value);if(item.node.nodeValue!==output)item.node.nodeValue=output;item.state.translated=output;};
    for (const element of document.body.querySelectorAll('[title],[aria-label],[aria-description],[placeholder],img[alt]')) {
      if (element.closest(excluded) || !visible(element) || element.matches('input[type="file"],input[type="password"],input[type="email"]')) continue;
      let states = attributeRecords.get(element);
      if (!states) {states={};attributeRecords.set(element,states);}
      for (const name of attributes) {
        if (!element.hasAttribute(name)) continue;
        const state = record(element,element.getAttribute(name),states[name]); states[name]=state;
        const key=source(state.original);
        if(key)items.push({key,state,write:value=>{if(element.getAttribute(name)!==value)element.setAttribute(name,value);state.translated=value;}});
      }
    }
    return items;
  }
  function save() {
    try {window.localStorage.setItem(cacheKey,JSON.stringify(Object.fromEntries(Object.entries(cache).slice(-12000))));} catch {}
  }
  function paint(items) {for(const item of items)if(cache[item.key])item.write(cache[item.key]);}
  function protect(text) {
    const tokens=[];
    const value=text.replace(/(?:USASTARFASHION|LabStudio|Printlab|DTF|PES|DST|PNG|SVG|PDF|DPI|Shop Pay|PayPal|Mastercard|Apple Pay|Google Pay|Klarna)\b|(?:[£$€¥₺]\s*[\d.,]+|[\d.,]+\s*(?:£GB|GBP|EUR|USD|£|€|₺))|\b\d+(?:[.,]\d+)?\s*(?:mm|cm|gsm|g\/m²|DPI)\b/gi,token=>{const key='ZXQ'+tokens.length+'QXZ';tokens.push(token);return key;});
    return {value,restore:translated=>translated.replace(/ZXQ\s*(\d+)\s*QXZ/gi,(_,index)=>tokens[Number(index)]??_)};
  }
  async function translate(keys) {
    if(keys.some(key=>key.length>1200)){
      for(const key of keys){
        if(key.length<=1200){await translate([key]);continue;}
        const chunks=[];let rest=key;
        while(rest.length>1200){let end=rest.lastIndexOf(' ',1200);if(end<200)end=1200;chunks.push(rest.slice(0,end));rest=rest.slice(end).trimStart();}
        if(rest)chunks.push(rest);
        for(const chunk of chunks)if(!cache[chunk])await translate([chunk]);
        cache[key]=chunks.map(chunk=>cache[chunk]).join(' ');
      }
      return;
    }
    const protectedTexts=keys.map(protect);
    const url='https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl='+encodeURIComponent(language)+'&dt=t&q='+encodeURIComponent(protectedTexts.map(x=>x.value).join('\n###\n'));
    const response=await nativeFetch(url,{credentials:'omit',signal:AbortSignal.timeout(15000)});
    if(!response.ok)throw Error('Translation unavailable');
    const data=await response.json();
    const joined=(data[0]||[]).map(part=>part[0]||'').join('');
    const parts=joined.split(/\s*###\s*/);
    if(parts.length!==keys.length)throw Error('Incomplete translation');
    keys.forEach((key,index)=>{const text=protectedTexts[index].restore(parts[index]).trim();if(text)cache[key]=text;});
  }
  async function run() {
    if (language==='en' || !document.body) return;
    if(running){scheduled=true;return;}
    running=true;scheduled=false;
    try {
      let items=collect();paint(items);
      const missing=[...new Set(items.map(item=>item.key))].filter(key=>!cache[key]&&!inFlight.has(key));
      // Render each small batch immediately; new tool panels do not wait for the whole site.
      for(let start=0;start<missing.length;){
        const group=[];let size=0;
        while(start<missing.length&&group.length<10&&(!group.length||size+missing[start].length<1200)){const key=missing[start++];group.push(key);size+=key.length;}
        group.forEach(key=>inFlight.add(key));
        try{await translate(group);failures=0;paint(collect());save();}
        catch{failures++;if(failures>=3)break;}
        finally{group.forEach(key=>inFlight.delete(key));}
      }
    } finally {running=false;if(scheduled)schedule();}
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(run,100);}
  window.USFLanguageSync={language,refresh:schedule};
  function boot(){
    if(language==='en')return;
    run();
    new MutationObserver(changes=>{
      if(changes.some(change=>change.type!=='attributes'||attributes.includes(change.attributeName)||['hidden','open','class'].includes(change.attributeName)))schedule();
    }).observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:[...attributes,'hidden','open','class']});
    document.addEventListener('click',schedule,true);
    document.addEventListener('change',schedule,true);
    window.addEventListener('online',schedule);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
